import React, { useEffect } from "react";
import { useAppDispatch } from "../../../state/store";
import { useCareRecipientIdFromPath } from "../../hooks/care_recipient/useCareRecipientIdFromPath";
import { selectCareRecipientAction } from "../../../state/usecase/care_recipient/actions";
import { useCareRecipientList } from "../../hooks/care_recipient/useCareRecipientList";
import { CareCommentThreadList } from "./CareCommentThreadList";
import { PinnedCareCommentList } from "./PinnedCareCommentList";
import { useChangeCareRecipient } from "../../hooks/common/useChangeCareRecipient";
import { Paths } from "../../../Paths";
import { useSelectCareRecipientFromPath } from "../../hooks/care_recipient/useSelectCareRecipientFromPath";
import { useScrollTop } from "../../hooks/common/useScrollTop";
import { Navigate } from "react-router-dom";

export function CareCommentListPage() {
    const dispatch = useAppDispatch();

    const { careRecipients } = useCareRecipientList();

    const careRecipientIdFromPath = useCareRecipientIdFromPath();
    useSelectCareRecipientFromPath();

    // ケアコメントの取得はサイドメニュー（SideMenuContent.tsx）で実施しているため、戻り値のCareRecipientIdはここでは利用せず、
    // 利用者変更に伴うURLの上書きを実行するのみ
    useChangeCareRecipient(`${Paths.careComment}`);

    useScrollTop();

    if (!careRecipientIdFromPath) {
        return <Navigate to={Paths.root} />;
    }

    useEffect(() => {
        const selectedCareRecipient = careRecipients.find(careRecipient => careRecipient.id.value === careRecipientIdFromPath.value) ?? null;

        if (selectedCareRecipient) {
            dispatch(selectCareRecipientAction({ id: selectedCareRecipient.id, name: selectedCareRecipient.name, houseId: selectedCareRecipient.houseId, customerCode: selectedCareRecipient.customerCode, branchCode: selectedCareRecipient.branchCode }));
        }
    }, [dispatch, careRecipients, careRecipientIdFromPath]);

    return (
        <div className={"care_comment_list_page"}>
            <div className={"container"}>
                <h1 className={"page_title"}>ケアコメント</h1>
                <ul className="care_comment_list pinned_list">
                    <div className={"lead_text"}>継続掲示</div>
                    <PinnedCareCommentList />
                </ul>
                <ul className={"care_comment_list"}>
                    <div className={"lead_text"}>ケアコメント一覧</div>
                    <CareCommentThreadList />
                </ul>
            </div>
        </div>
    );
}
